import { applyContent } from 'apis/AiChat/AiChat';
import { useMutation } from 'react-query';
export const useApplyContent = () => {
  return useMutation(({ chatId, messageId }: { chatId: string; messageId: string }) => applyContent(chatId, messageId));
};
